module.exports = __webpack_public_path__ + "img/no_result_forum.78b0f8b7.svg";